import { create } from 'zustand';

import { InitializationState, InitializationStates } from './types';

type EppoStoreType = {
  initializationState: InitializationState;
  setInitializationState: (state: InitializationState) => void;
};

export const useEppoStore = create<EppoStoreType>((set) => ({
  initializationState: InitializationStates.UNINITIALIZED,
  setInitializationState: (state) => set({ initializationState: state }),
}));
